import {observer} from "mobx-react";
import {Drawer} from "../../../../../components/drawer/drawer";
import DefaultDrawerLayout from "../../../../../components/drawer/layouts/default-drawer-layout";
import Hr from "../../../../../components/hr/hr";
import currentPortalStore from "../../../../../stores/current-portal-store";
import CustomerCaseStore from "../../stores/customer-case-store";
import RmaPageStore from "../../stores/rma-page-store";
import ProductCaseDrawerContents from "./rma-product-case-drawer-contents";
import ProductCaseDrawerHeader from "./rma-product-case-drawer-header";
import './rma-product-case-drawer.scss';
import ValidateItemButtons from "./validate-items/validate-item-buttons";
import ValidateItemWrapper from "./validate-items/validate-item-wrapper";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";

interface IProps {
    customerCaseStore?: CustomerCaseStore;
    rmaPageStore: RmaPageStore;
}

const ProductCaseDrawer: React.FC<IProps> = observer(({customerCaseStore, rmaPageStore}) => {
    if (!customerCaseStore?.selectedProductCase) {
        return null;
    }

    const onCloseClick = () => {
        rmsMixpanelStore.trackEvent('d&_original_item_more_close');
        customerCaseStore.unsetProductCase();
    }

    return (
        <Drawer
            closeButton={{onClick: onCloseClick}}
        >
            <DefaultDrawerLayout
                drawerHeader={
                    <div className={'rma-page-product-case-drawer'}>
                        <ProductCaseDrawerHeader customerCaseStore={customerCaseStore}/>
                    </div>
                }
                drawerBody={
                    <div className={'rma-page-product-case-drawer'}>
                        <div className="drawer-content-shadow"></div>
                        <ProductCaseDrawerContents productCaseStore={customerCaseStore.selectedProductCase}/>
                        
                        {customerCaseStore?.selectedProductCase.wasReceived() && currentPortalStore.setting?.isValidationEnabled &&
                         <Hr/> &&
                         <ValidateItemWrapper productCaseStore={customerCaseStore?.selectedProductCase}/>
                        }
                    </div>
                }
                drawerFooter={
                    <ValidateItemButtons productCaseStore={customerCaseStore?.selectedProductCase} rmaPageStore={rmaPageStore}/>
                }
            />
        </Drawer>
    );
});

export default ProductCaseDrawer;
